import { render, staticRenderFns } from "./ClientFormAdmin.vue?vue&type=template&id=e973d70a&"
import script from "./ClientFormAdmin.vue?vue&type=script&lang=js&"
export * from "./ClientFormAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports